import React from 'react';
import _ from 'lodash';
import { Field } from 'redux-form';
import renderSelect from './renderSelect';
import ModuleContentCard from './ModuleContentCard';
import '../assets/css/components/ngss-search-form.css';

const NgssSearchForm = ({ controls, searchFormValues, modules, module, initialValues, dimensionCollection, results, handleCardClick }) => {
  const getContentTypeOptions = ()=> {
    let baseOptions = [{ id: '1', text: 'Quests' }, { id: '2', text: 'Storylines' }]
    if(_.isEmpty(module)) {
      baseOptions.push({ id: '3', text: 'Modules' })
    }
    return baseOptions
  }

  const getDefaultContentTypes = ()=> {
    let baseOptions = ['1','2']
    if(_.isEmpty(module)) {
      baseOptions.push('3')
    }
    return baseOptions
  }

  return(
    <div className='ngss-content-search'>
      <form>
        {controls &&
        <div>
          <div className='row'>
            <div className='col-md-6'>
              <Field
                name='contentTypes'
                component={renderSelect}
                label='Content Types'
                defaultValue={getDefaultContentTypes()}
                multiple
                data={getContentTypeOptions()}
              />
            </div>
            <div className='col-md-6'>
              <Field
                wrapperClass='pes'
                name='pes'
                component={renderSelect}
                label='PEs'
                defaultValue={[]}
                multiple
                data={dimensionCollection.pes}
              />
            </div>
          </div>
          <Field
            wrapperClass='dcis'
            name='dcis'
            component={renderSelect}
            label='DCIs'
            defaultValue={[]}
            multiple
            data={dimensionCollection.dcis}
          />
          <Field
            wrapperClass='seps'
            name='seps'
            component={renderSelect}
            label='SEPs'
            defaultValue={[]}
            multiple
            data={dimensionCollection.seps}
          />
          <Field
            wrapperClass='cccs'
            name='cccs'
            component={renderSelect}
            label='CCCs'
            defaultValue={[]}
            multiple
            data={dimensionCollection.cccs}
          />
        </div>}
      </form>
      <br/>

      {_.isEmpty(results) &&
        <h3>Sorry, we don't have any content of this type.</h3>
      }
      {_.map(results, result =>
        <ModuleContentCard key={result.id} content={result} handleClick={()=>handleCardClick(result)}/>
      )}
    </div>
  );
}

export default NgssSearchForm;
